// configuration for the UI only
import { env } from '@/root/env.mjs';

import type { UiConfig } from './uiConfigTypes';
import { uiDevConfig } from './uiDev.config';
import { uiProdConfig } from './uiProd.config';
import { uiStageConfig } from './uiStage.config';

function validateConfig(config: UiConfig): UiConfig {
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value === 'undefined' || (!value && typeof value === 'string')) {
      throw new Error(`Missing required config: ${key}`);
    }
  });

  return config;
}

let uiConfig: UiConfig;

switch (env.NEXT_PUBLIC_ENVIRONMENT) {
  case 'production':
    uiConfig = validateConfig(uiProdConfig);
    break;

  case 'stage':
    uiConfig = validateConfig(uiStageConfig);
    break;

  case 'dev':
  default:
    uiConfig = validateConfig(uiDevConfig);
    break;
}

export { uiConfig };
